export default [
    {
        value: {
            value: 'Autorización',
            id: 1
        },
        label: 'Autorización',
    }, {
        value: {
            value: 'Rechazo',
            id: 4
        },
        label: 'Rechazo',
    }, {
        value: {
            value: 'Anulación',
            id: 5
        },
        label: 'Anulacíon',
    }
];
